import React from "react";
import { CountryCode } from "../../../model/common/country";
import { PaymentPlan } from "../../../service/contract/solar-recommendation";

export type EmploymentCategory = "businessOwner" | "employee";

export type NextStepData = {
	countryCode?: string;
	employmentCategory?: EmploymentCategory;
	paymentPlan?: number;
};

export type GetSolarViewState =
	| "landing"
	| "payment-plan"
	| "employment-information-zambia"
	| "identity-information-zambia"
	| "contact-information-zambia"
	| "meter-information-zambia"
	| "energy-requirements"
	| "installation"
	| "confirmation"
	| "progress-page"
	| "tailored-recommendations-page"
	| "pay-as-you-go-info-page"
	| "billing-information-page"
	| "billing-information-form"
	| "thank-you-page";

export const VIEW_FLOW: Record<GetSolarViewState, { prev?: (data?: NextStepData) => GetSolarViewState; next?: (data?: NextStepData) => GetSolarViewState }> = {
	landing: { next: () => "payment-plan" },
	"payment-plan": {
		prev: () => "landing",
		next: (data) => data?.countryCode === CountryCode.Zambia ? "employment-information-zambia" : "energy-requirements",
	},
	"employment-information-zambia": {
		prev: () => "payment-plan",
		next: (data) => data?.employmentCategory === "employee" ? "identity-information-zambia" : "contact-information-zambia",
	},
	"identity-information-zambia": {
		prev: () => "employment-information-zambia",
		next: () => "meter-information-zambia",
	},
	"contact-information-zambia": {
		prev: () => "employment-information-zambia",
		next: () => "meter-information-zambia",
	},
	"meter-information-zambia": {
		prev: (data) => data?.employmentCategory === "employee" ? "identity-information-zambia" : "contact-information-zambia",
		next: () => "energy-requirements",
	},
	"energy-requirements": {
		prev: (data) => data?.countryCode === CountryCode.Zambia ? "meter-information-zambia" : "payment-plan",
		next: () => "installation",
	},
	"installation": {
		prev: () => "energy-requirements",
		next: () => "confirmation",
	},
	"confirmation": {
		prev: () => "installation",
	},
	"progress-page": {
		prev: () => "landing",
	},
	"tailored-recommendations-page": {
		prev: () => "landing",
		next: (data) => data?.paymentPlan === PaymentPlan.PayAsYouGo ? "pay-as-you-go-info-page" : "landing",
	},
	"pay-as-you-go-info-page": {
		prev: () => "tailored-recommendations-page",
		next: () => "billing-information-page",
	},
	"billing-information-page": {
		prev: () => "pay-as-you-go-info-page",
		next: () => "billing-information-form",
	},
	"billing-information-form": {
		prev: () => "billing-information-page",
	},
	"thank-you-page": {},
};

export interface PaymentPlanOption {
	id: number;
	label: string;
	icon: React.ReactNode;
}
